export const version = "sha2/5.8.0";
//# sourceMappingURL=_version.js.map